import { useState, useLayoutEffect, useEffect, useMemo } from "react";
import { every, isInteger } from "lodash/fp";
import { ResizeObserver as ResizeObserver$1 } from "@juggle/resize-observer";
import { useHandler } from "./use-handler.es.js";
const MyResizeObserver = typeof ResizeObserver !== "undefined" ? ResizeObserver : ResizeObserver$1;
const areIntegers = every(isInteger);
function useHorizontalScroll(ref = {}) {
  const [atBeginning, setBeginning] = useState(true);
  const [atEnd, setEnd] = useState(true);
  const [scrollable, setScrollable] = useState(false);
  const onScroll = useHandler((event) => {
    const { offsetWidth, scrollLeft, scrollWidth } = event.target;
    if (areIntegers([offsetWidth, scrollLeft, scrollWidth])) {
      setBeginning(scrollLeft === 0);
      setEnd(scrollLeft >= scrollWidth - offsetWidth);
      setScrollable(scrollWidth > offsetWidth);
    }
  });
  const scrollBack = useHandler(() => {
    const node = ref.current;
    const { offsetWidth, scrollLeft } = node;
    if (areIntegers([offsetWidth, scrollLeft])) {
      node.scrollLeft = Math.max(0, scrollLeft - offsetWidth);
    }
  });
  const scrollForward = useHandler(() => {
    const node = ref.current;
    const { offsetWidth, scrollLeft, scrollWidth } = node;
    if (areIntegers([offsetWidth, scrollLeft, scrollWidth])) {
      node.scrollLeft = Math.min(
        scrollWidth - offsetWidth,
        scrollLeft + offsetWidth
      );
    }
  });
  const handleOuterResize = useHandler(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    const { offsetWidth, scrollLeft, scrollWidth } = node;
    if (areIntegers([offsetWidth, scrollLeft, scrollWidth])) {
      setBeginning(scrollLeft === 0);
      setEnd(scrollLeft >= scrollWidth - offsetWidth);
      setScrollable(scrollWidth > offsetWidth);
    }
  });
  useLayoutEffect(() => {
    handleOuterResize();
  }, [handleOuterResize]);
  useEffect(() => {
    const node = ref.current;
    if (!(node instanceof HTMLElement)) {
      return void 0;
    }
    const resizeObserver = new MyResizeObserver(handleOuterResize);
    resizeObserver.observe(node);
    return () => {
      resizeObserver.unobserve(node);
    };
  }, [handleOuterResize, ref]);
  return useMemo(
    () => ({
      atBeginning,
      atEnd,
      onScroll,
      scrollable,
      scrollBack,
      scrollForward
    }),
    [atBeginning, atEnd, onScroll, scrollBack, scrollForward, scrollable]
  );
}
export {
  useHorizontalScroll
};
